<template>
  <streaming-line-chart
    ref="statsCountChart"
    :height="300"
    :chart-data="chartData"
    :dataset="dataset"
    :is-started="isStarted"
    :options="chartOption"
    :time-scale="scala"
  />
</template>

<script>
import StreamingLineChart from '@/components/Charts/StreamingLineChart.js'

export default {
  components: {
    StreamingLineChart
  },
  props: {
    isStarted: {
      type: Boolean,
      required: true,
      default: false
    },
    dataset: {
      type: Array,
      required: true
    },
    scala: {
      type: Number,
      required: true
    }
  },
  computed: {
    chartOption () {
      const self = this
      return {
        legend: {
          position: 'top',
          align: 'start'
        },
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false
              },
              type: 'realtime',
              realtime: {
                duration: 60000,
                refresh: 50,
                delay: 10,
                pause: true
              },
              time: {
                minUnit: 'second'
              }
            }
          ],
          yAxes: [
            {
              type: 'linear',
              display: true,
              gridLines: {
                color: self.darkMode
                  ? 'rgba(0, 0, 0, 0.1)'
                  : 'rgba(100, 100, 100, 1)'
              },
              ticks: {
                maxTicksLimit: 3,
                callback: function (value, index, values) {
                  return value.toFixed(2)
                }
              }
            }
          ]
        },
        tooltips: {
          enabled: false
        },
        events: [],
        hover: {
          enabled: false
        },
        elements: {
          point: {
            radius: 0
          }
        }
      }
    },
    chartData () {
      return {
        datasets: [
          {
            label: this.$t('unit_rate_t'),
            fill: false,
            borderColor: '#0bb4ff',
            cubicInterpolationMode: 'monotone',
            data: []
          }
        ]
      }
    }
  }
}
</script>
